import dayjs from "dayjs"

export async function useDownloadBlob(blob: Blob, fileName: string, addDateTimePrefix = true, organizationName?: string) {
  const url = URL.createObjectURL(blob)
  useDownloadUrl(url, fileName, addDateTimePrefix, organizationName)
}

export async function useDownloadUrl(url: string, fileName: string, addDateTimePrefix = true, organizationName?: string) {
  const link = document.createElement("a")
  link.style.visibility = "hidden"
  link.setAttribute("href", url)

  const organizationDescription = organizationName ? organizationName.replaceAll(" ", "-").toLowerCase() + "_" : ""

  if (addDateTimePrefix) {
    const currentDateTime = dayjs().format("YYYY-MM-DD_HH-mm-ss")
    link.setAttribute("download", `${currentDateTime}_${organizationDescription}${fileName}`)
  } else {
    link.setAttribute("download", `${organizationDescription}${fileName}`)
  }

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
